/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import JSG from '@cedalo/jsg-ui';


const {
	CommandStack: JSGCommandStack,
	Notification,
	NotificationCenter
} = JSG;

const sendNotification = (command, type, commandStack) => {
	// eslint-disable-next-line
	NotificationCenter.getInstance().send(new Notification(CommandStack.STACK_CHANGED_NOTIFICATION, { command, type, commandStack }));
}

class CommandStack extends JSGCommandStack {

	execute(cmd) {
		const oldsize = this.undostack.length;
		super.execute(cmd);
		if (this.undostack.length !== oldsize) {
			sendNotification(cmd, 'execute', this);
		}
	}

	redo() {
		const cmd = super.redo();
		if (cmd) sendNotification(cmd, 'redo', this);
		return cmd;
	}

	undo() {
		const cmd = super.undo();
		if (cmd) sendNotification(cmd, 'undo', this);
		return cmd;
	}
}
CommandStack.STACK_CHANGED_NOTIFICATION = 'dl.stack.changed.notification';

// export default CommandStack;
// SERVER_COMMANDS:
// eslint-disable-next-line import/first, import/newline-after-import
import RequestCommandStack from './RequestCommandStack';
export default RequestCommandStack(CommandStack);
//  ~